<template>
  <main
    class="training d-flex justify-content-center align-items-center text-center"
  >
    <div class="train">
      <h1>Training</h1>
      <p>
        We offer digital skills training programs that cover coding, web
        development, digital marketing, data analytics, and more. Our programs
        are designed to give learners the knowledge, tools, and practical
        experience to excel in the digital landscape.
      </p>
    </div>
  </main>
  <section class="">
    <div class="my-program pt-5 pb-3">
      <div class="container-fluid">
        <div class="programs text-center mb-5">
          <h2>Our training programmes</h2>
          <p>
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint.
          </p>
        </div>
       
      </div> 
      <div class="nav-box">
          <ul class="nav nav-pills" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="easy-tab"
                data-bs-toggle="tab"
                data-bs-target="#onsite-page"
                type="button"
                role="tab"
                aria-controls="easy"
                aria-selected="true"
              >
                Onsite Training
              </button>
            </li>

            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="camptab"
                data-bs-toggle="tab"
                data-bs-target="#kodecamp"
                type="button"
                role="tab"
                aria-controls="colors"
                aria-selected="false"
              >
                Online Training
              </button>
            </li>

            <!-- <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="features-tab"
                data-bs-toggle="tab"
                data-bs-target="#features"
                type="button"
                role="tab"
                aria-controls="features"
                aria-selected="false"
              >
                Tech Camp
              </button>
            </li>

            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="features2-tab"
                data-bs-toggle="tab"
                data-bs-target="#features2"
                type="button"
                role="tab"
                aria-controls="features2"
                aria-selected="false"
              >
                Corporate Training
              </button>
            </li> -->
          </ul>
        </div>
      <!-- for onsite page -->
      <div class="tab-content mt-5" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="onsite-page"
          role="tab"
          aria-labelledby="easy-tab"
        >
          <Onsite />
        </div>
        <!-- for kodecamp -->
        <div
          class="tab-pane fade show"
          id="kodecamp"
          role="tab"
          aria-labelledby="easy-tab"
        >
          <Kode />
        </div>
      </div>
      <div class="py-5">
        <Contact />
      </div>
    </div>
  </section>
</template>

<script>
import Onsite from "@/components/Onsite.vue";
import Contact from "@/components/Contact.vue";
import Kode from "@/components/Kode.vue";

export default {
  components: {
    Onsite,
    Kode,
    Contact,
  },
};
</script>

<style scoped>
* {
  font-family: "Inter", sans-serif;
}
.training {
  background: url(../assets/Images/training.png);
  height: 100vh;
  object-fit: cover;
  background-size: cover;
  background-position: center;
  background-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.1);
}
.train h1 {
  font-style: normal;
  font-weight: 700;
  font-size: 64px;
  line-height: 77px;
}
.train p {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  /* line-height: 150%;
  padding: 0 396px; */
}
.train {
  color: #ffffff;
  width: 50%;
}

.my-program {
  background: #f9f9f9;
}
.programs h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  color: #1f1f1f;
}

.my-program .nav-box {
  display: flex;
  justify-content: center;
}

.programs p {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #595959;
}
.using p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #404040;
}
.nav-link {
  background: none !important;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #666666 !important;
}
.my-program .nav-link.active {
  font-weight: 900 !important;
  color: #335ca6 !important;
}

/*  for tabs links */
.nav-link:focus,
.nav-pills:focus {
  opacity: 5;
  font-weight: 900;
  color: #335ca6 !important;
}

ul {
  margin-left: 0px;
}

.link {
  text-decoration: none;
  font-weight: bold;
}

/* for margins */

.reversing {
  padding: 4rem 0;
}

/* for responsiveness */
@media screen and (max-width: 768px) {
  .training {
    height: 360px;
  }

  .train h1 {
    font-size: 46px;
  }
  .train {
    width: 70%;
  }
  .programs p {
    font-size: 18px;
  }

  .nav-pills .nav-link.active {
    background: none !important;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #666666 !important;
  }
}

@media screen and (max-width: 426px) {
  .train {
    width: 90%;
  }

  .programs h2 {
    font-size: 22px;
  }
}
@media screen and (max-width: 375px) {
}
@media screen and (max-width: 320x) {
}
</style>